import Cookies from 'js-cookie'

document.addEventListener('DOMContentLoaded', function () {
  const getContactForm = () => document.querySelector('.wpcf7 form.wpcf7-form');

  const handleStatusChanged = (event) => {
    const form = getContactForm();
    const status = event.detail?.status;
    if (form && (status === 'validation_failed' || status === 'invalid')) {
      form.classList.add('was-validated');
    }
  };

  const addWasValidatedClass = () => {
    const form = getContactForm();
    if (form) {
      form.classList.add('was-validated');
    }
  };

  const removeWasValidatedClass = () => {
    const form = getContactForm();
    if (form) {
      form.classList.remove('was-validated');
    }
  };

  const formControlSelector = '.form-control, .form-select';

  const fieldValidationMessageMap = {
    'contact-name': {
      errorValidation: 'Enter your full name.'
    },
    'contact-phone': {
      errorValidation: 'Enter your 10-digit phone number.'
    },
    'contact-help': {
      errorValidation: 'Select an option.'
    },
    'contact-email': {
      errorValidation: 'Enter your email address in this format: name@example.com.'
    }
  };

  // Treat CF7-required fields the same as native required inputs
  const isRequiredLikeField = (field) => {
    if (!field) return false;

    return field.required ||
      field.getAttribute('aria-required') === 'true' ||
      field.classList.contains('wpcf7-validates-as-required');
  };

  // Get the validation config for a field based on its name or id
  const getFieldValidationConfig = (field) => {
    if (!field) return null;

    const keys = [
      (field.getAttribute('name') || '').toLowerCase(),
      (field.id || '').toLowerCase()
    ].filter(Boolean);

    const matchedKey = keys.find(key => fieldValidationMessageMap[key]);
    return matchedKey ? fieldValidationMessageMap[matchedKey] : null;
  };

  // Get the validation message for a field
  const getValidationMessage = (field, fallback = '') => {
    const config = getFieldValidationConfig(field);
    return config?.errorValidation || fallback;
  };

  // Force floating labels for all form controls within CF7 form wraps
  jQuery('.wpcf7-form-control-wrap').each(function () {
    var label = jQuery(this).next('label').detach();
    var field = jQuery(this).find('.form-control, .form-select');
    jQuery(this).append(label).addClass('form-floating');
    if (field) {
      field.val('');
    }
  })

  // Remove CF7's validation feedback and classes
  const removeFieldError = (field) => {
    if (!field) return;
    field.classList.remove('is-invalid');
    field.classList.remove('is-valid');

    const wrapper = field.closest('.wpcf7-form-control-wrap') || field.parentNode;
    if (wrapper) {
      wrapper.querySelectorAll('.invalid-feedback[data-cf7-validation="true"], .invalid-feedback[data-phone-validation="true"]').forEach(feedback => feedback.remove());
    }
  };

  // Clear all validation styles/messages
  const clearFormErrors = (form) => {
    if (!form) return;

    form.querySelectorAll(formControlSelector).forEach(input => {
      input.classList.remove('is-invalid');
      input.classList.remove('is-valid');
    });
    form.querySelectorAll('.invalid-feedback[data-cf7-validation="true"], .invalid-feedback[data-phone-validation="true"]').forEach(feedback => feedback.remove());
  };

  // Add Bootstrap .invalid-feedback element for each field
  const addFieldError = (field, message) => {
    if (!field) return;
    removeFieldError(field);
    field.classList.add('is-invalid');
    field.classList.remove('is-valid');

    const feedbackDiv = document.createElement('div');
    feedbackDiv.classList.add('invalid-feedback');
    feedbackDiv.dataset.cf7Validation = 'true';
    feedbackDiv.innerText = message;
    field.insertAdjacentElement('afterend', feedbackDiv);
  };

  // Find email input by checking type, name, id, autocomplete, and inputmode attributes
  const isEmailLikeField = (field) => {
    if (!field) return false;
    const fieldName = (field.getAttribute('name') || '').toLowerCase();
    const fieldId = (field.id || '').toLowerCase();
    const autocomplete = (field.getAttribute('autocomplete') || '').toLowerCase();
    const inputMode = (field.getAttribute('inputmode') || '').toLowerCase();

    return [field.type, autocomplete, inputMode].includes('email') ||
      fieldName.includes('email') ||
      fieldId.includes('email');
  };

  // Regex pattern for valid email addresses
  const hasValidEmailPattern = (value) => {
    const trimmedValue = (value || '').trim();
    if (!trimmedValue) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
  };

  // Keep custom validity in sync with strict email rules before checking validity
  const syncStrictEmailValidity = (field) => {
    if (!isEmailLikeField(field)) return;

    const value = (field.value || '').trim();
    if (!value) {
      if (isRequiredLikeField(field)) {
        field.setCustomValidity(getValidationMessage(field, 'Enter your email address.'));
      } else {
        field.setCustomValidity('');
      }
      return;
    }

    if (hasValidEmailPattern(value)) {
      field.setCustomValidity('');
    } else {
      field.setCustomValidity(getValidationMessage(field, 'Enter your email address in this format: name@example.com.'));
    }
  };

  const isFormattedPhoneField = (field) => {
    if (!field) return false;

    const fieldName = (field.getAttribute('name') || '').toLowerCase();
    const fieldId = (field.id || '').toLowerCase();

    return fieldName === 'contact-phone' || fieldId === 'contact-phone';
  };

  const syncRequiredLikeFieldValidity = (field) => {
    if (!field || isEmailLikeField(field) || isFormattedPhoneField(field)) {
      return;
    }

    if (!isRequiredLikeField(field)) {
      field.setCustomValidity('');
      return;
    }

    const value = typeof field.value === 'string' ? field.value.trim() : field.value;
    if (value) {
      field.setCustomValidity('');
    } else {
      field.setCustomValidity(getValidationMessage(field, 'Complete this field.'));
    }
  };

  const syncContactFieldValidity = (field) => {
    if (isFormattedPhoneField(field)) {
      validateFormattedPhone(field);
      return;
    }

    syncStrictEmailValidity(field);
    syncRequiredLikeFieldValidity(field);
  };

  // Map native validity states
  const getMappedValidationMessage = (field) => {
    if (!field || !field.validity) return '';

    const hasMappedInvalidState = field.validity.valueMissing ||
      field.validity.patternMismatch ||
      field.validity.typeMismatch ||
      field.validity.tooShort ||
      field.validity.tooLong;

    if (hasMappedInvalidState) {
      return getValidationMessage(field);
    }

    return '';
  };

  // Live-clearing is only allowed when field is fully valid
  const canClearLiveFieldError = (field) => {
    if (!field || !field.checkValidity()) return false;

    if (isEmailLikeField(field)) {
      return hasValidEmailPattern(field.value);
    }

    return true;
  };

  // Track forms after first submit, then allow live validation
  const submittedForms = new WeakSet();

  // CF7 events can target wrappers; normalize back to the underlying form
  const getOwningForm = (element) => {
    if (!element) return null;
    if (element.matches && element.matches('form')) return element;
    if (element.querySelector) {
      const nestedForm = element.querySelector('form');
      if (nestedForm) return nestedForm;
    }
    return element.closest ? element.closest('form') : null;
  };

  const hasSubmittedOnce = (field) => {
    const form = getOwningForm(field);
    return !!form && submittedForms.has(form);
  };

  // Field validation
  const validateFieldFeedback = (field) => {
    if (!field) return;

    syncContactFieldValidity(field);

    if (canClearLiveFieldError(field)) {
      return removeFieldError(field);
    }

    addFieldError(field, getMappedValidationMessage(field) || field.validationMessage || '');
  };

  // Bind validation
  const bindLiveFieldValidation = (field) => {
    if (!field || field.dataset.liveValidationBound === 'true') return;

    const validateField = () => {
      if (!hasSubmittedOnce(field)) {
        return;
      }

      validateFieldFeedback(field);
    };

    ['change', 'blur'].forEach(eventName => {
      field.addEventListener(eventName, validateField);
    });

    field.dataset.liveValidationBound = 'true';
  };

  const validateAndBindField = (field) => {
    validateFieldFeedback(field);
    bindLiveFieldValidation(field);
  };

  // Reset validation state for wpcf7mailsent
  const handleMailSentValidationReset = () => {
    const form = getContactForm();
    if (!form) return;

    removeWasValidatedClass();
    clearFormErrors(form);
    submittedForms.delete(form);
  };

  // Disply thank you message after submit
  const handleMailSentThankYou = () => {
    const form = getContactForm();
    const message = document.querySelector('.thank-you-message');
    const wrapper = form ? form.closest('.wpcf7') : null;

    if (wrapper) {
      wrapper.remove();
    }
    if (message) {
      message.style.display = 'block';
    }
  };

  // Invalid form handler
  const handleInvalidForm = (event) => {
    const form = getContactForm();
    if (!form) return;

    submittedForms.add(form);
    addWasValidatedClass();
    clearFormErrors(form);

    // Apply CF7 validation messages first
    const detailedErrors = event.detail?.apiResponse?.invalid_fields;
    const cf7InvalidFieldNames = new Set();

    if (Array.isArray(detailedErrors) && detailedErrors.length) {
      detailedErrors.forEach(function(error) {
        cf7InvalidFieldNames.add(error.field);

        const inputField = form.querySelector(`[name="${error.field}"]`);

        if (inputField) {
          addFieldError(inputField, error.message);
          bindLiveFieldValidation(inputField);
        }
      });
    }

    // Then custom validation messages
    form.querySelectorAll(formControlSelector).forEach(input => {
      syncContactFieldValidity(input);

      const inputName = input.getAttribute('name');
      if (inputName && cf7InvalidFieldNames.has(inputName)) {
        bindLiveFieldValidation(input);
        return;
      }

      validateAndBindField(input);
    });
  };

  // First submit pass: mark form as submitted and validate
  const handleFormSubmit = (event) => {
    const submitForm = event.currentTarget;
    submittedForms.add(submitForm);
    submitForm.classList.remove('was-validated');
    submitForm.querySelectorAll(formControlSelector).forEach(validateFieldFeedback);

    const hasInvalidField = Array.from(submitForm.querySelectorAll(formControlSelector)).some(input => !input.checkValidity());
    if (hasInvalidField) {
      event.preventDefault();
      event.stopPropagation();
      submitForm.classList.add('was-validated');
    }
  };

  const contactReferralInput = document.getElementById('contact-referral');
  if (contactReferralInput) {
    contactReferralInput.value = Cookies.get('odcUIDLandingPage') || '';
  }

  const form = getContactForm();
  if (form) {
    form.querySelectorAll(formControlSelector).forEach(bindLiveFieldValidation);
  }

  // Auto-format phone fields
  const formattedPhonePattern = /^\(\d{3}\)\s\d{3}-\d{4}$/;
  const phoneValidationMessage = fieldValidationMessageMap['contact-phone']?.errorValidation || 'Enter your 10-digit phone number.';

  const disallowNonNumericInput = (e) => {
    if (e.ctrlKey || e.metaKey) { return; }
    if (e.key !== undefined && e.key.length > 1) { return; }
    if (/[0-9]/.test(e.key)) { return; }
    e.preventDefault();
  };

  const disallowNumericInput = (e) => {
    if (e.ctrlKey || e.metaKey) { return; }
    if (e.key !== undefined && e.key.length > 1) { return; }
    if (/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  // Force phone number formatting
  const formatToPhone = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(-10);
    const areaCode = digits.substring(0, 3);
    const prefix = digits.substring(3, 6);
    const suffix = digits.substring(6, 10);

    if (digits.length > 6) { e.target.value = `(${areaCode}) ${prefix}-${suffix}`; }
    else if (digits.length > 3) { e.target.value = `(${areaCode}) ${prefix}`; }
    else if (digits.length > 0) { e.target.value = `(${areaCode}`; }
    else if (digits.length == 0) { e.target.value = ''; }
  };

  // Apply phone number validation
  const validateFormattedPhone = (input) => {
    if (!input) return;

    const value = input.value.trim();

    if (!value) {
      if (isRequiredLikeField(input)) {
        input.setCustomValidity(getValidationMessage(input, phoneValidationMessage));
      } else {
        input.setCustomValidity('');
      }
      return;
    }

    if (formattedPhonePattern.test(value)) {
      input.setCustomValidity('');
    } else {
      input.setCustomValidity(getValidationMessage(input, phoneValidationMessage));
    }
  };

  const phoneInput = document.querySelector('#contact-phone');
  if (phoneInput) {
    phoneInput.setAttribute('pattern', '\\(\\d{3}\\)\\s\\d{3}-\\d{4}');
    phoneInput.addEventListener('keydown', disallowNonNumericInput);
    phoneInput.addEventListener('input', (e) => {
      formatToPhone(e);
    });
  };

  const nameInput = document.querySelector('#contact-name');
  if (nameInput) {
    nameInput.addEventListener('keydown', disallowNumericInput);
  };

  // Event listeners
  document.addEventListener('wpcf7submit', addWasValidatedClass, false);
  document.addEventListener('wpcf7statuschanged', handleStatusChanged, false);
  document.addEventListener('wpcf7invalid', addWasValidatedClass, false);
  document.addEventListener('wpcf7mailsent', removeWasValidatedClass, false);

  document.addEventListener('wpcf7mailsent', handleMailSentThankYou, false);
  document.addEventListener('wpcf7invalid', handleInvalidForm, false);
  document.addEventListener('wpcf7mailsent', handleMailSentValidationReset, false);

  if (form) {
    form.addEventListener('submit', handleFormSubmit, true);
  }
});